import React, { useState } from "react";

import StarIcon from '@atlaskit/icon/glyph/star';
import StarFilledIcon from '@atlaskit/icon/glyph/star-filled';
import EditIcon from '@atlaskit/icon/glyph/edit';
import Spinner from '@atlaskit/spinner';

import { Link } from "react-router-dom";

import FileIcon from "components/FileIcon";


import 'components/Table/Cells/index.css';

import './index.css';


const getStar = ({ id, isStarred, onStar, hover, loading, size = 'medium' }) => {
    let Icon;
    let className = '';

    if (loading) {
        Icon = Spinner;
    } else if (!isStarred) {
        Icon = StarIcon;
    } else {
        Icon = StarFilledIcon;
    }

    if (hover) {
       className = 'starred-cell__icon--show' 
    }

    return (
        <div
            className={`starred-cell__icon ${className}`}
            onClick={onStar}
        >
            <span>
                <Icon size={size}/>
            </span>
        </div>
    )
}

const getEditIcon = ({ hover, onEdit, showEditIcon }) => {
    let className = '';

    if (!showEditIcon) return null;

    if (hover) {
        className = 'starred-cell__icon--show' 
     }
 
    return (
        <div
            className={`starred-cell__icon ${className}`}
            onClick={onEdit}
        >
            <span>
                <EditIcon />
            </span>
        </div>
    )
}

function Starred(props) {
    const [hover, setHover] = useState(false);

    const {
        isDir,
        isStarred,
        linkGenerator,
        loading,
        name,
        onEdit,
        onStar,
        isSelected,
        selectedBackgroundColor = 'transparent',
        showIcon = true,
        showEditIcon = true,
        size,
        textClassName = ''
    } = props;

    const backgroundColor = 'transparent';

    return (
        <div
            key={props.id}
            className='starred-cell'
            onMouseOver={() => setHover(true)}
            onMouseOut={() => setHover(false)}
            style={{
                backgroundColor: isSelected ? selectedBackgroundColor : backgroundColor
            }}
        >
            {
                showIcon &&
                <FileIcon item={name} is_dir={isDir}/>
            }
            {
                linkGenerator ?
                <Link
                    className={`starred-cell__p--normal cell__p ${textClassName}`}
                    to={linkGenerator()}
                    onClick={e => e.stopPropagation()}
                >
                    {name}&nbsp;
                </Link>
                :
                <p
                    className={`starred-cell__p--normal cell__p ${textClassName}`}
                >
                    {name}&nbsp;
                </p>
            }
            {
                getStar({
                    isStarred,
                    onStar,
                    hover,
                    loading,
                    size
                })
            }
            {
                getEditIcon({
                    onEdit,
                    hover,
                    showEditIcon
                })
            }
        </div>
    )
}

export default Starred;